





















































import Vue from "vue";
import { v4 as uuidv4 } from "uuid";
import { Trans } from "@/shared/scripts/helpers/translation/translation";

export default Vue.extend({
    props: {
        formAction: {
            type: String,
            required: false,
            default: ""
        },
        formLabel: {
            type: String,
            required: false,
            default: ""
        },
        formToken: {
            type: String,
            required: false,
            default: ""
        },
        /**
         * [displayLabel Display (or not) the label of the input]
         */
        displayLabel: {
            type: Boolean,
            required: false,
            default: true
        },
        isInModal: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data: function() {
        return {
            immocodeFocused: false as boolean,
            classifiedId: "" as string,
            isCodeInvalid: false as boolean,
            immowebCodeId : "ImmowebCode-" + uuidv4() as string,
            inputClass: "input--text input-search" as string
        };
    },
    computed: {
        activeLanguage: function (): string {
            return Trans.currentLocale;
        },
        pathUrl: function(): string {
            return `${process.env.VUE_APP_IMMOWEB_URL}/${this.activeLanguage}` as string;
        },
        setURL: function ():string {
            switch(this.activeLanguage) {
            case "fr":
                return `${this.pathUrl}/annonce/${this.classifiedId}`;
            case "nl":
                return `${this.pathUrl}/zoekertje/${this.classifiedId}`;
            default:
                return `${this.pathUrl}/classified/${this.classifiedId}`;
            }
        },
    },
    mounted: function () {
        if(this.isInModal) {
            this.inputClass = "input--text input-search input--modal";
        }
    },
    methods: {
        onSubmit: function(e:Event) {
            this.isCodeInvalid = false;
            this.classifiedId = this.classifiedId.trim();
            if (!this.isImmocode()) {
                this.isCodeInvalid = true;
                e.preventDefault();
            }
        },
        onFocus: function() {
            this.immocodeFocused = true;
            this.isCodeInvalid = false;
        },
        onBlur: function() {
            this.immocodeFocused = false;
            this.isCodeInvalid = false;
        },
        isImmocode: function() {
            return this.classifiedId && /^\d{6,10}$/.test(this.classifiedId);
        }
    }
});
